import { Component, OnInit, OnDestroy, NgZone, ElementRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { VoiceWriting2Service, VoiceWritingState } from './../../services/voiceWriting2.service'
import { FormGroup } from '@angular/forms';
import { VoiceCommand } from '../../services/voiceWriting2.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-voice-writing2',
  templateUrl: './voice-writing2.component.html',
  styleUrls:['./voice-writing2.component.css'],
  animations: [
    trigger('slideDown', [
      state('in', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => *', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate(300, style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition('* => void', [
        animate(300, style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class VoiceWriting2Component implements OnInit, OnDestroy {
    @ViewChild('observationsTextarea', { static: false }) observationsTextarea!: ElementRef;
    @ViewChild('treatmentTextarea', { static: false }) treatmentTextarea!: ElementRef;
  public voiceState: VoiceWritingState = {
    isListening: false,
    isActive: false,
    isDictating: false,
    activeElement: null,
    lastCommand: null,
    error: null,
    processingCommand: false,
    currentField:null,
    uppercaseMode:false,
    networkStatus: 'online', //  red
    isRecovering: false //  recuperación

  };

  public isVoiceSupported = false;
  public showDebugInfo = false;
  public showDebugControls = false; // Cambiar a true para habilitar controles de debug

  private subscriptions: Subscription[] = [];
  public sixForm!: FormGroup;

  @Input() stopSignal: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stopSignal'] && changes['stopSignal'].currentValue) {
      this.voiceState.processingCommand = false;
    }
  }
showRecoverySuccess = false;
  private recoverySuccessTimeout: any;
  private currentRetryCount = 0;
  private maxRetries = 10;

  constructor(
    private voiceWritingService: VoiceWriting2Service,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.checkVoiceSupport();

  // 🔎 Verificar estado de red al iniciar
  this.voiceWritingService.testNetworkConnectivity()
    .then(isOnline => {
      this.voiceWritingService.updateState({
        networkStatus: isOnline ? 'online' : 'offline',
        isRecovering: !isOnline
      });
    });
    // Suscribirse al estado del servicio
    this.subscriptions.push(
      this.voiceWritingService.state$.subscribe(state => {
        // Asegurar que las actualizaciones se ejecuten en la zona de Angular
        this.ngZone.run(() => {
          this.voiceState = state;
           this.handleFieldFocus();
        });
      })
    );

    //this.voiceWritingService.test

        // Suscribirse a los comandos ejecutados
    this.subscriptions.push(
      this.voiceWritingService.commandExecuted$.subscribe(command => {
        this.handleVoiceCommand(command);
      })
    );
    //  Suscribirse a comandos de UI para notificaciones de red
    this.voiceWritingService.uiCommands$.subscribe(command => {
      this.handleUICommand(command);
    });

    //END
        // En desarrollo, habilitar controles de debug
    this.showDebugControls = !this.isProduction();
  }

 onRestartVoiceService() {
    this.voiceWritingService.reinitialize();
  }

  ngOnDestroy(): void
  {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.voiceWritingService.stopVoiceWriting();
    if (this.recoverySuccessTimeout) {
      clearTimeout(this.recoverySuccessTimeout);
    }

    this.voiceWritingService.cleanup();
  }

  toggleVoiceWriting(): void {
    // Verificar estado de red antes de iniciar
    console.log("Entra en toogleVoiceWriting");
    console.log("this.voiceState.networkStatus es:", this.voiceState.networkStatus);
    if (this.voiceState.networkStatus !== 'online') {
      console.warn('No se puede iniciar - red no disponible');
      return;
    }

    if (this.voiceState.isActive) {
      this.voiceWritingService.stopVoiceWriting();
    } else {
      this.voiceWritingService.startVoiceWriting();
    }
  }


 public getActiveFieldText(): string {
  const activeElement = this.voiceWritingService.getActiveElement();

  if (!activeElement) {
    return 'Ningún campo seleccionado';
  }

  const element = activeElement as HTMLElement;

  // Manejar campos de Angular Material
  if (element.classList.contains('mat-input-element')) {
    const formField = element.closest('mat-form-field');
    if (formField) {
      const label = formField.querySelector('mat-label')?.textContent?.trim();
      if (label) return `Campo: ${label}`;
    }
  }

  // Lógica anterior...
 }



  public clearError(): void {
    // Método para limpiar errores manualmente
    this.voiceWritingService['updateState']({ error: null });
  }

  public checkVoiceSupport(): void {
    this.isVoiceSupported = this.voiceWritingService.isVoiceWritingSupported();
  }

  public toggleDebugInfo(): void {
    this.showDebugInfo = !this.showDebugInfo;
  }

  public logDebugInfo(): void {
    const debugInfo = this.voiceWritingService.getDebugInfo();
    console.log('🐛 Voice Writing Debug Info:', debugInfo);
    console.log('🐛 Current Voice State:', this.voiceState);
    console.log('🐛 Active Element:', this.voiceWritingService.getActiveElement());

    // También mostrar información del documento
    console.log('🐛 Document Active Element:', document.activeElement);
    console.log('🐛 Voice Support:', this.isVoiceSupported);
  }

  private getElementDisplayName(element: HTMLElement): string {
    // Buscar label asociado
    const id = element.id;
    if (id) {
      const label = document.querySelector(`label[for="${id}"]`);
      if (label && label.textContent) {
        return label.textContent.trim();
      }
    }

    // Buscar en mat-form-field
    const matFormField = element.closest('mat-form-field');
    if (matFormField) {
      const matLabel = matFormField.querySelector('mat-label');
      if (matLabel && matLabel.textContent) {
        return matLabel.textContent.trim();
      }
    }

    // Usar atributos del elemento
    const placeholder = element.getAttribute('placeholder');
    const formControlName = element.getAttribute('formControlName');
    const name = element.getAttribute('name');
    const ariaLabel = element.getAttribute('aria-label');

    return placeholder || formControlName || name || ariaLabel || 'Campo de texto';
  }

  private isProduction(): boolean {
    // Detectar si estamos en producción
    return window.location.hostname !== 'localhost' &&
           window.location.hostname !== '127.0.0.1' &&
           !window.location.hostname.includes('dev');
  }

    // Método para ser llamado desde el componente padre
    public setFormGroup(formGroup: FormGroup): void {
      this.sixForm = formGroup;
    }


      private handleVoiceCommand(command: VoiceCommand): void
      {
        console.log("Entra a handleVoiceCommand");
        switch (command.command) {
          case 'NAVIGATE':
            this.navigateToField(command.targetField!);
            break;

          // case 'APPEND_TEXT':
          //   this.appendTextToField(command.text!, command.targetField!);
          //   break;

          // case 'DELETE':
          //   this.deleteFromField(command.targetField!);
          //   break;

          // case 'CLEAR':
          //   this.clearField(command.targetField!);
          //   break;
        }
      }

    private navigateToField(fieldName: string): void {
      console.log("Entra a navigateToField")
    const textarea = this.getTextareaElement(fieldName);
    console.log("En navigateToFiel textArea es:", textarea);
    if (textarea) {
      textarea.focus();
      // Posicionar cursor al final
      const textLength = textarea.value.length;
      textarea.setSelectionRange(textLength, textLength);
    }
  }

    private getTextareaElement(fieldName: string): HTMLTextAreaElement | null {
    const selector = `textarea[formControlName="${fieldName}"]`;
    return document.querySelector(selector) as HTMLTextAreaElement;
  }

  private handleFieldFocus(): void
  {
    if (this.voiceState.currentField) {
      const textarea = this.getTextareaElement(this.voiceState.currentField);
      if (textarea) {
        setTimeout(() => {
          textarea.focus();
          textarea.classList.add('textarea-focused');

          // Remover la clase después de 2 segundos
          setTimeout(() => {
            textarea.classList.remove('textarea-focused');
          }, 2000);
        }, 100);
      }
    }
  }
  //Manejar comandos de UI del servicio
  private handleUICommand(command: any): void {
    switch (command.type) {
      case 'network-recovered':
        this.showRecoverySuccessMessage();
        break;
      case 'network-recovery-failed':
        this.handleRecoveryFailure();
        break;
      case 'open-tooth-select':
        // ... manejo existente
        break;
      // ... otros comandos
    }
  }

  //Mostrar mensaje de recuperación exitosa
  private showRecoverySuccessMessage(): void {
    this.showRecoverySuccess = true;

    // Auto-ocultar después de 4 segundos
    if (this.recoverySuccessTimeout) {
      clearTimeout(this.recoverySuccessTimeout);
    }

    this.recoverySuccessTimeout = setTimeout(() => {
      this.showRecoverySuccess = false;
    }, 4000);
  }

  //  Manejar fallo de recuperación
  private handleRecoveryFailure(): void {
    // Puedes mostrar un modal o toast específico
    console.log('Recuperación de red falló - intervención manual necesaria');
  }

  //  Reinicio manual de red
  manualNetworkRestart(): void {
    console.log('🔄 Usuario solicitó reinicio manual de red');
    this.voiceWritingService.manualNetworkRestart();
  }

  //  Obtener texto del estado de red
  getNetworkStatusText(): string {
    switch (this.voiceState.networkStatus) {
      case 'online':
        return 'Conectado';
      case 'offline':
        return 'Sin conexión';
      case 'recovering':
        return 'Reconectando';
      default:
        return 'Desconocido';
    }
  }

  //  Obtener texto del contador de reintentos
  getCurrentRetryText(): string {
    // Esta información deberías obtenerla del servicio
    // Por ahora simulo el contador
    return `${this.currentRetryCount}/${this.maxRetries}`;
  }

  //  Calcular progreso de recuperación
  getRecoveryProgress(): number {
    if (!this.voiceState.isRecovering) return 0;

    // Simular progreso basado en tiempo o reintentos
    const progress = (this.currentRetryCount / this.maxRetries) * 100;
    return Math.min(progress, 90); // No mostrar 100% hasta que termine
  }

  //  Verificar si es error de red
  isNetworkError(error: string): boolean {
    if (!error) return false;

    const networkErrorKeywords = [
      'red', 'network', 'conexión', 'internet',
      'conectividad', 'offline', 'desconectado'
    ];

    return networkErrorKeywords.some(keyword =>
      error.toLowerCase().includes(keyword)
    );
  }

  recoverFromNetworkError()
  {
    this.voiceWritingService.recoverFromNetworkError();
  }


}
